import '../../App.less';
import {Spin,Badge, Layout,Tabs, Select,Comment,Avatar, Row, Col,ConfigProvider,Table,Modal,Menu,Input, Space,notification,AutoComplete, Card, Checkbox,Transfer } from 'antd';
import React, { Component } from "react";
import 'react-phone-input-2/lib/style.css'
import es_ES from 'antd/lib/locale/es_ES';
import { Button } from 'antd';
import Highlighter from 'react-highlight-words';
import {ShareAltOutlined,HomeOutlined, ReadOutlined, UserOutlined,MinusOutlined,CheckOutlined,StarOutlined,MailOutlined, PhoneOutlined, GlobalOutlined, EnvironmentOutlined, IdcardOutlined, LikeOutlined,DislikeOutlined, SearchOutlined,CalendarOutlined,EditOutlined, UnorderedListOutlined,TagsOutlined,FileTextOutlined,FilePdfOutlined, AuditOutlined,QrcodeOutlined,BarChartOutlined } from '@ant-design/icons';
import moment from 'moment'
import axios from "axios";
import generatePDFConc from './services/reportGenerator' 
import generatePDFPlay from './services/reportGeneratorPlays' 
import {getAuthors,getAuthorsStr, getCountryName,IP,getCountryCode, countDownNotification, getPon, getPonStr} from '../components/utils';
import Foot from "../components/Footer"
import AdminMenu from "../components/AdminMenu"
import EmailIcon from '@iconscout/react-unicons/icons/uil-envelope'

class Playslist extends Component {
  constructor(props){
    super(props)
    this.state={
      plays:[],
      showArticle:false,
      record:null,
      recordAuthor:null,
      edit:false,
      conc:[],
      filteredInfo:[],
      reportCountry:null,
      makeCountryReport:false,
      selectedRows:[],
      qualifiedChanged:false,
      qualifiedChangedValue:undefined,
      preselectedChanged:false,
      preselectedChangedValue:undefined,
      showCommentSection:false,
      comment:{},
      edit_comment:undefined,
      selected_comment:undefined,
      comment_new_text:undefined,
      comment_answer_text:undefined,
      jurys_dict:{},
      juryId:undefined,
      logued:false,
      reportByAuthor:true,
      isBusy:false,
      showAuthor:false,
      showAddPonencias:false,
      unassignedPlays:[],
      assignedPlays:[],
    }
  }
  async componentDidMount() {
    //Plays
    const response_plays = await fetch(IP + 'api/culturasOriginarias/ponencia/',{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
    },
    });
    const json_plays = await response_plays.json();
    if(json_plays['detail']){
      localStorage.clear()
      window.location.reload(); 
    }
    
    
    var data = []
    this.authorsStr = new Set();
    this.auths = new Set();
    this.codes = new Set();
    this.titles = new Set();
    this.dates = new Set();
    this.pseudos = new Set();
    this.edits = [];
    this.countries = new Set();
    
    
    const Moment = require('moment');
   
    const json_conc = [].concat.apply([],json_plays.map(play=> {return play.conc})) 
    for(var i in json_plays){
      var item = json_plays[i];
      var date= new Moment(item.fecha_registro).format('DD-MM-YYYY')
      var author= getAuthors(item.conc)
      var a= getAuthorsStr(item.conc)
      for(var j in a ){
        this.authorsStr.add(a[j])
      }
      const year = date.split('-')[2]
      
      var authorStr = getAuthorsStr(item.conc).join(", ")
      this.auths.add(author)
      this.codes.add(year+'_'+item.id);
      this.titles.add(item.titulo);
      this.dates.add(date);
      this.edits.push("")
      this.countries.add(getCountryName(item.conc[0].pais))

      console.log("PONENCIA CONC",item.conc)
      data.push(
          { 
              key : item.id,
              id : item.id,
              title : item.titulo,
              author: author ,
              conc:item.conc,
              authorStr:authorStr,
              date:date,
              unixDate: new Moment(item.fecha_registro).unix(),
              pseudo: item.pseudonimo,
              code:year+'_'+item.id,
              conc: item.conc,
              edit:'',
              qualified:item.califica,
              resumen: item.resumen,
              email_sended: item.correo_enviado
              
          });
    
    };
    var data_conc = []

    this.names = new Set();
    this.emails = new Set();
    
    for(var i in json_conc){
      var item = json_conc[i];
      console.log("CONC",item)
      this.names.add(item.nombre + ' ' + item.apellidos)
      this.emails.add(item.email)
      data_conc.push(
          { 
              id : item.id,
              name : item.nombre + ' ' + item.apellidos,
              country: item.pais,
              countryName: getCountryName(item.pais),
              ficha: item.sintesis,
              phone: item.telefono,
              address: item.direcc_personal,
              email: item.email,
              pronoun: item.pronombre,
              village: item.pueblo,
              social: item.redes,
              organization: item.organizacion,
              participation: item.participacionVirtual
          });
    };
    this.auths = [...this.auths].map((v)=>{
      return {value:v}
    })
    
    this.codes = [...this.codes].map((v)=>{
      return {value:v}
    })
    this.titles = [...this.titles].map((v)=>{
      return {value:v}
    })
    this.dates = [...this.dates].map((v)=>{
      return {value:v}
    })

    this.pseudos = [...this.pseudos].map((v)=>{
      return {value:v}
    })
    
    this.authorsStr = [...this.authorsStr].map((v)=>{
      return {value:v}
    })

    console.log("CONCUUU",data_conc)
    this.setState({ plays: data , conc:data_conc, filteredInfo:data, isBusy:false,logued:true});
   
  }
  
  async getPlays(){//loads all plays and its details
    const Moment = require('moment');
    var data = []
    this.setState({isBusy:true})
    const response = await fetch(IP + 'api/culturasOriginarias/ponencia/',{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
    },
    });
    const json = await response.json();
    if(json['detail']){
      localStorage.clear()
      window.location.reload(); 
    }
    for(var i in json){
      var item = json[i];
      var date= new Moment(item.fecha_registro).format('DD-MM-YYYY')
      var author= getAuthors(item.conc)
      const year = date.split('-')[2]
      var authorStr = getAuthorsStr(item.conc).join(", ")
      data.push(
          { 
            key : item.id,
            id : item.id,
            title : item.titulo,
            author: author ,
            conc:item.conc,
            authorStr:authorStr,
            date:date,
            pseudo: item.pseudonimo,
            code:year+'_'+item.id,
            pdf:item.pdf,
            edit:'',
            qualified:item.califica,
          });
    };
    this.setState({ plays: data,isBusy:false})
  }

  async changeQualification(id,value,preselectedValue){
    var options = {
      method: "patch",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"},
      proxy: {
        host: 'localhost:8000',
        port: 8000
      }
    }
    
    var playChanged={
      "califica":value,
     
  }
    await axios.patch(IP + `api/culturasOriginarias/ponencia/${id}/`, playChanged, options)
    .then(
      (response) => {
        if(response.status === 200){
           this.getPlays()
        }
         
         else{
           notification.error({
           message:'Error',
           description:'Hubo un error, por favor revise los datos',
         });
         }
      },
      (error) => {
       notification.error({
         message:'Error',
         description:'Hubo un error, por favor revise los datos',
       });
      }
    ).catch((err) => notification.error({
     message:'Error',
     description:'Hubo un error, por favor revise los datos',
   }))
  }
  
  onClickSavePlays=()=>{
    this.setState({showAddPonencias:false})
}
  async qualifyAll(){
    this.setState({isBusy:true})
    var data={}
    data['ids'] =  this.state.selectedRows
    data['califica'] = true
    
   var options = {
      method: "put",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"},
      body:JSON.stringify(data)
     
    }
    await fetch(IP + `api/culturasOriginarias/ponencia/`, options)
    .then(
      async(response) => {
        if(response.status === 200 || response.status === 201){
          var data={}
          data['ids'] =  this.state.selectedRows
          var userId = localStorage.getItem("UserId")

          data['usuario'] = userId
          data['accion'] = "Estado de obra cambiado a calificada"
          
          var options = {
              method: "post",
              credentials: "same-origin",
              headers: {
                "Authorization": localStorage.getItem("Authorization") ,
                "Accept": "application/json",
                "Content-Type": "application/json"},
              body:JSON.stringify(data)
            }
          fetch(IP + `api/culturasOriginarias/logs/`, options).then(response=> this.getPlays())
        }
      },
      (error) => {
        this.setState({isBusy:false})
        countDownNotification(notification.error,'Error','Por favor intente más tarde','error');
      }
    ).catch((err) => countDownNotification(notification.error,'Error','Por favor intente más tarde','error'))
  }
  async undefinedQualifyAll(){
    this.setState({isBusy:true})
    var data={}
    data['ids'] =  this.state.selectedRows
    data['califica'] = "undefined"
    data['preseleccionada'] = "undefined"
    
   var options = {
      method: "put",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"},
      body:JSON.stringify(data)
     
    }
    await fetch(IP + `api/culturasOriginarias/obra/`, options)
    .then(
      async(response) => {
       if(response.status === 200 || response.status === 201){
        var data={}
        data['ids'] =  this.state.selectedRows
        var userId = localStorage.getItem("UserId")

        data['usuario'] = userId
        data['accion'] = "Estado de obra cambiado a descalificada"
        
        var options = {
            method: "post",
            credentials: "same-origin",
            headers: {
              "Authorization": localStorage.getItem("Authorization") ,
              "Accept": "application/json",
              "Content-Type": "application/json"},
            body:JSON.stringify(data)
          
          }
        fetch(IP + `api/culturasOriginarias/logs/`, options).then((response)=>this.getPlays())
       }
       
      },
      (error) => {
        console.log(error);
      }
    ).catch((err) => console.log(err))
  }
  async unqualifyAll(){
    this.setState({isBusy:true})
    var data={}
    data['ids'] =  this.state.selectedRows
    data['califica'] = false
    data['preseleccionada'] = false
    
   var options = {
      method: "put",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"},
      body:JSON.stringify(data)
     
    }
    await fetch(IP + `api/culturasOriginarias/obra/`, options)
    .then(
      async(response) => {
       if(response.status === 200 || response.status === 201){
        var data={}
        data['ids'] =  this.state.selectedRows
        var userId = localStorage.getItem("UserId")

        data['usuario'] = userId
        data['accion'] = "Estado de obra cambiado a descalificada"
        
        var options = {
            method: "post",
            credentials: "same-origin",
            headers: {
              "Authorization": localStorage.getItem("Authorization") ,
              "Accept": "application/json",
              "Content-Type": "application/json"},
            body:JSON.stringify(data)
          }
        fetch(IP + `api/culturasOriginarias/logs/`, options).then((response)=>this.getPlays())
      }
      },
      (error) => {
        console.log(error);
      }
    ).catch((err) => console.log(err))
  }
  

  onClickArticle = record  => {
        this.setState({showArticle:true,record:record});
  };
  onchangeTab(tab){
    var plays = []
    if(tab=="1"){//all plays
      plays = this.state.plays
    }
    if(tab=="2"){//qualified
      plays = this.state.plays.filter(p=>p.qualified)
    }
    if(tab=="3"){//not qualified
      plays = this.state.plays.filter(p=>p.qualified==undefined ? false:!p.qualified)
    }
    if(tab=="4"){//not analyzed to be qualified
      plays = this.state.plays.filter(p=>p.qualified==undefined)
    }
    if(tab=="5"){//preselected
      plays = this.state.plays.filter(p=>p.preselected)
    }
    if(tab=="6"){//not preselected
      plays = this.state.plays.filter(p=>p.preselected==undefined ? false:!p.preselected)
    }
    if(tab=="7"){//not analyzed to be preselected
      plays = this.state.plays.filter(p=>p.preselected==undefined)
    }
   
    this.authorsStr = new Set();
    this.auths = new Set();
    this.codes = new Set();
    this.titles = new Set();
    this.dates = new Set();
    this.pseudos = new Set();
    this.countries = new Set();
    plays.forEach(play =>{
      var a= getAuthorsStr(play.conc)
      for(var j in a ){
        this.authorsStr.add(a[j])
      }
      this.auths.add(play.author)
      this.codes.add(play.code)
      this.titles.add(play.title)
      this.dates.add(play.date)
      this.pseudos.add(play.pseudo)
      this.countries.add(getCountryName(play.conc[0].pais))
    })
    this.auths = [...this.auths].map((v)=>{
      return {value:v}
    })
    
    this.codes = [...this.codes].map((v)=>{
      return {value:v}
    })
    this.titles = [...this.titles].map((v)=>{
      return {value:v}
    })
    this.dates = [...this.dates].map((v)=>{
      return {value:v}
    })

    this.pseudos = [...this.pseudos].map((v)=>{
      return {value:v}
    })
    
    this.authorsStr = [...this.authorsStr].map((v)=>{
      return {value:v}
    })
    this.setState({selectedRows:[]})
  }

 
  hideModal = () => {
        this.setState({
          showArticle: false,
          record: null,
        });
  };

  hideEdit = () => {
    this.setState({
      edit: false,
      record: null,
    });
};

  onClickEditPlay(record){
        this.setState({edit:true,record:record});
  };

  handleTableChange = (pagination, filters, sorter, extra) => {
    this.setState({
      filteredInfo: extra['currentDataSource']
    });
  }
  onChangeSelectedRows(rows){
    this.setState({selectedRows:rows})
  }

  getAutocomplete = (dataIndex) =>{
    if(dataIndex == "code"){
      return this.codes
    }
    
      else if (dataIndex == "title" ) {
        return this.titles
    } 

    else if (dataIndex== "author"){
      return  this.authorsStr
    }

   
    else if (dataIndex== "pseudo"){
      return this.pseudos
    }
    
    else{
      return this.dates
    }
  }
  handleTransferChange = (newTargetKeys, direction, moveKeys) => {
    direction=='left'? this.setState({ assignedPlays:[...newTargetKeys] }): this.setState({ assignedPlays:this.state.assignedPlays.concat(moveKeys) })
  };
async onClickSave(){

  var options = {
     method: "patch",
     credentials: "same-origin",
     headers: {
       "Authorization": localStorage.getItem("Authorization") ,
       "Accept": "application/json",
       "Content-Type": "application/json"},
     proxy: {
       host: '200.55.135.1',
       port: 8000
     }
   }
   
   var playChanged={}
   var preselectedValue = this.state.preselectedChanged?this.state.preselectedChangedValue:this.state.record.preselected
   var qualifiedValue = this.state.qualifiedChanged?this.state.qualifiedChangedValue:this.state.record.qualified
     playChanged={
       titulo: document.getElementById("inputTitle").value,
       pseudonimo: document.getElementById("inputPseudo").value,
       califica:preselectedValue ? true : qualifiedValue,
     }
   await axios.patch(IP + `api/culturasOriginarias/obra/${this.state.record.id}/`, playChanged, options)
   .then(
     (response) => {
       if(response.status === 200){
        var userId = localStorage.getItem("UserId")
        if(this.state.preselectedChanged){
          const data_log= new FormData()
          data_log.append('usuario',userId)
          data_log.append('accion',preselectedValue ? "Estado de obra cambiado a preseleccionada":"Estado de obra cambiado a no preseleccionada")
          data_log.append('obra',this.state.record.id)
          axios.post(IP + 'api/culturasOriginarias/logs/', data_log)
        }

        if(this.state.qualifiedChanged){
          const data_log= new FormData()
          data_log.append('usuario',userId)
          data_log.append('accion',qualifiedValue ? "Estado de obra cambiado a calificada":"Estado de obra cambiado a descalificada")
          data_log.append('obra',this.state.record.id)
          axios.post(IP + 'api/culturasOriginarias/logs/', data_log)
        }
         window.location.reload();
       }
        
        else{
          notification.error({
          message:'Error',
          description:'Hubo un error, por favor revise los datos',
        });
        }
     },
     (error) => {
      notification.error({
        message:'Error',
        description:'Hubo un error, por favor revise los datos',
      });
     }
   ).catch((err) => notification.error({
    message:'Error',
    description:'Hubo un error, por favor revise los datos',
  }))
   this.setState({qualifiedChanged:false,preselectedChanged:false})
 }
  getColumnSearchProps = (dataIndex,nombre) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <div style={{ padding: 8 }}>
            <AutoComplete 
            style={{ width: 188, marginBottom: 8, display: 'block' }}
            options={this.getAutocomplete(dataIndex)}
            filterOption={(inputValue,option)=>option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
            onChange={(value)=>{setSelectedKeys(value ? [value] : [])}}
            value={selectedKeys[0]}

            >
              <Input
                ref={node => {
                  this.searchInput = node;
                }}
                placeholder={`Buscar ${nombre}`}
                onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
              />
            </AutoComplete>
            <Space>
              <Button
                type="primary"
                onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                icon={<SearchOutlined />}
                size="small"
                style={{ width: 90 }}
              >
                Buscar
              </Button>
              <Button onClick={() =>{setSelectedKeys([]); this.handleReset(clearFilters)}} size="small" style={{ width: 90 }}>
                Resetear
              </Button>
            </Space>

          </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
          dataIndex!="author"?
           (record[dataIndex]
            ? record[dataIndex].toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase())
            : ''):
            (record[dataIndex]? record[dataIndex].some(auth=>auth['name'].normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase())):'')
       ,
        onFilterDropdownVisibleChange: visible => {
          if (visible) {
            setTimeout(() => this.searchInput.select(), 100);
          }
        },
        render: (text,record,index) =>

           this.state.searchedColumn === dataIndex ? (
             dataIndex !="author"?
            (<div style={{fontSize:'large' }}>
            <Highlighter
              highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={text ? text.toString() : ''}
            />
            </div>):
            record[dataIndex].map(auth=>
            (<div style={{fontSize:'large' }}>
            <Highlighter
              highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={auth['name'] ? auth['name'] : ''}
            />
            </div>))
          ) : (
            <div style={{fontSize:'large' }}>
              {(dataIndex=='edit' && <a onClick={()=>{this.onClickEditPlay(record)}}> <EditOutlined /></a>)||(dataIndex=="author" && <ol>{record.author.map((a,idx)=>{return <li><a onClick = {()=>this.setState({showAuthor:true,record:record,recordAuthor:a.id})} >{a.name}</a> </li>})}</ol> )
              || (<a onClick = {()=>this.onClickArticle(record)} >  {text}</a> )  }
            </div>
          ),
      });
    
      handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        this.setState({
          searchText: selectedKeys[0],
          searchedColumn: dataIndex,
        });
      };
    
      handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });

      };
      
      getDataFromURL = (url) => new Promise((resolve, reject) => {
        setTimeout(() => {
            fetch(url)
                .then(response => response.text())
                .then(data => {
                    resolve(data)
                });
        });
    }, 2000);

  render() {
    /////Authors////
    const downloadPlayReport =()=> generatePDFPlay(this.state.plays,"save")
    const readPlayReport =()=> generatePDFPlay(this.state.plays,"read")

 

    const downloadCurrentReport =()=> generatePDFPlay(this.state.filteredInfo,"save")
    const readCurrentReport =()=> generatePDFPlay(this.state.filteredInfo,"read")

    const downloadPlayReportSelectedCountry=()=> generatePDFPlay(this.state.plays.filter(p=>Object.entries(p.conc)[0][1]['pais'] == getCountryCode(this.state.reportCountry)),"save",false,true,this.state.reportCountry)
    const readPlayReportSelectedCountry =()=> generatePDFPlay(this.state.plays.filter(p=>Object.entries(p.conc)[0][1]['pais'] == getCountryCode(this.state.reportCountry)),"read",false,true,this.state.reportCountry)

    
    const downloadPlayReportPseudo =()=> generatePDFPlay(this.state.plays,"save",false,false,'',false)
    const readPlayReportPseudo =()=> generatePDFPlay(this.state.plays,"read",false,false,'',false)

    const downloadPlayReportGenrePseudo =()=> generatePDFPlay(this.state.plays,"save",true,false,'',false)
    const readPlayReportGenrePseudo =()=> generatePDFPlay(this.state.plays,"read",true,false,'',false)

    const downloadCurrentReportPseudo =()=> generatePDFPlay(this.state.filteredInfo,"save",false,false,'',false)
    const readCurrentReportPseudo =()=> generatePDFPlay(this.state.filteredInfo,"read",false,false,'',false)

    const downloadPlayReportSelectedCountryPseudo=()=> generatePDFPlay(this.state.plays.filter(p=>Object.entries(p.conc)[0][1]['pais'] == this.getCountryCode(this.state.reportCountry)),"save",false,true,this.state.reportCountry,false)
    const readPlayReportSelectedCountryPseudo =()=> generatePDFPlay(this.state.plays.filter(p=>Object.entries(p.conc)[0][1]['pais'] == this.getCountryCode(this.state.reportCountry)),"read",false,true,this.state.reportCountry,false)

   
    ///Conc////
    const downloadConcReport =()=> generatePDFConc(this.state.conc,"save")
    const readConcReport =()=> generatePDFConc(this.state.conc,"read")
    ////


const onClickGenreReport=()=>{
  this.setState({makeGenreReport:true})
}
const onClosekGenreReport=()=>{
  this.setState({makeGenreReport:false})
}
const onChangeReportGenre = (value) =>{this.setState({reportGenre:value})}


const onClickCountryReport=()=>{
  this.setState({makeCountryReport:true})
}
const onClosekCountryReport=()=>{
  this.setState({makeCountryReport:false})
}
const onChangeReportCountry = (value) =>{this.setState({reportCountry:value})}
      const {  Content } = Layout;
      const columns = [
                
                 
                  {
                    title: <div style={{fontWeight:'bold', fontSize:'large'}}>Título</div>,
                    dataIndex: 'title',
                    key: 'title',
                    sorter: (a, b) => a.title.localeCompare(b.title),
                    ...this.getColumnSearchProps('title','título'),
                    responsive: ['sm'] 
                  },
                  
                  {
                    title: <div style={{fontWeight:'bold', fontSize:'large'}}>Autor(es)</div>,
                    dataIndex: 'author',
                    key: 'author',
                    ...this.getColumnSearchProps('author','autor'),
                    responsive: ['sm'] 
                  },
                 
                  {
                    title: <div style={{fontWeight:'bold', fontSize:'large'}}>Fecha</div>,
                    dataIndex: 'date',
                    key: 'date',
                    width:'8%',
                    sorter:(a,b) => moment.utc(a.unixDate).diff(moment.utc(b.unixDate)),
                    sortDirections:['ascend', 'descend', 'ascend'],
                    ...this.getColumnSearchProps('date','fecha'),
                    responsive: ['sm'] 
                  },
                  {
                    title: <div style={{fontWeight:'bold', fontSize:'large'}}>Calificada</div>,
                    dataIndex: 'qualified',
                    key: 'qualified',
                    width:'100px',
                    render: (text,record) =>(
                      <Row  align="middle" justify="center"  >
                        <Col >
                            {record.qualified != undefined ? (record.qualified ? <a onClick={()=>this.changeQualification(record.id,null)}><LikeOutlined  style={{color:'green'}} /></a>:<a onClick={()=>this.changeQualification(record.id,true)}> <DislikeOutlined  /></a>): <a onClick={()=>this.changeQualification(record.id,false)}> <MinusOutlined /></a>}
                        </Col>
                      </Row>
                      ),
                    sortDirections:['ascend', 'descend', 'ascend'],
                    responsive: ['sm'] ,
                    sortDirections:['ascend', 'descend', 'ascend'],
                    responsive: ['sm'] 
                  },
                  
                  {
                    title: <div style={{fontWeight:'bold', fontSize:'large' }}>Obra</div>,
                    sorter: (a, b) => a.name.localeCompare(b.name),
                    sortDirections:['ascend', 'descend', 'ascend'],
                    ...this.getColumnSearchProps('name','nombre'),
                    render: (record) => (
                      <React.Fragment>
                        <a onClick = {()=>this.onClickArticle(record)} >   
                        <b style={{fontSize:'large'}}>{record.title}</b>
                        </a>

                       
                        <br />
                        <b>Seudónimo:</b>{record.pseudo}
                        <br />
                        <b>Autor(es):</b><ol>{record.author.map((a,idx)=>{return <li>{a.name} </li>})}</ol> 
                        <br />
                        <b>Fecha:</b>{record.date}
                      </React.Fragment>
                    ),
                    responsive: ['xs'] 
                  },
                  {
                    dataIndex: 'edit',
                    key: 'edit',
                    width:'15%',
                    render: (text,record) =>(
                                <div  style={{fontSize:'large' }}>
                                <a onClick={()=>{this.onClickEditPlay(record)}}> <EditOutlined /></a>
                                </div>
                    ),
                    sortDirections:['ascend', 'descend', 'ascend'],
                    responsive: ['xs'] 
                  },
            ];

    const url = this.state.record?.pdf
    const downloadUrl = IP + 'api/culturasOriginarias/file/'+ this.state.record?.id

    const readFile =  ()=>{
      window.open(url)
    };
    const downloadFile=()=>{
      fetch(downloadUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/pdf"
        }
      })
        .then(res => res.blob())
        .then(response => {
          //Create a Blob from the PDF Stream
          const blob = new Blob([response], {
            type: "application/pdf"
          });
          //Build a URL from the file
          // const fileURL = URL.createObjectURL(file);

          const link = document.createElement('a');
          // create a blobURI pointing to our Blob
          link.href = URL.createObjectURL(blob);
          link.download = this.state.record.code;
          // some browser needs the anchor to be in the doc
          document.body.append(link);
          link.click();
          link.remove();
          // in case the Blob uses a lot of memory
          setTimeout(() => URL.revokeObjectURL(link.href), 7000);
          //Open the URL on new Window
          // window.open(fileURL);
        })
        .catch(error => {
          console.log(error);
        });
    }

    const closeComments=()=>{
      this.setState({showCommentSection:false,editComment:false, selected_comment:undefined})
    }
    const { SubMenu } = Menu;
    const { Option } = Select;
    const { TabPane } = Tabs;
    const { TextArea } = Input;
    const reportMenu = (
      <SubMenu disabled={!this.state.logued} key="reports" icon={<BarChartOutlined style={{ fontSize: '26px'}} />} style={{fontSize:'20px', fontWeight:'bold', color:'black'}} title="Reportes">
        <SubMenu  key="play" title ={<h4 style={{ fontWeight:'bold', color:'black'}}>Reportes de obras</h4>}>
          <SubMenu  key="playAuth" title ={<h4 style={{ fontWeight:'bold', color:'black'}}>Con autores</h4>}>
            <Menu.ItemGroup title={<h4 style={{  color:'black'}}>General</h4>}>
              <Menu.Item>
                  <Button onClick={readPlayReport}>Ver</Button> <Button onClick={downloadPlayReportPseudo}>Descargar</Button>
              </Menu.Item>
            </Menu.ItemGroup>

       
              
            <Menu.ItemGroup title={<h4 style={{  color:'black'}}>Tabla actual</h4>}>
              <Menu.Item>
                  <Button onClick={readCurrentReport}>Ver</Button> <Button onClick={downloadCurrentReport}>Descargar</Button>
              </Menu.Item>
            </Menu.ItemGroup>
            
            <Menu.Item>
              <h4 onClick={()=>{this.setState({reportByAuthor:true},()=>onClickCountryReport())}}  style={{  color:'black'}}>Por país específico</h4>
            </Menu.Item>

            <Menu.Item style={{ fontWeight:'bold'}} >
              <h4 onClick={()=>{this.setState({reportByAuthor:true},()=>onClickGenreReport())}}  style={{  color:'black'}}>Por Genero</h4>
            </Menu.Item>
          </SubMenu>
          <SubMenu  key="playPseudo" title ={<h4 style={{ fontWeight:'bold', color:'black'}}>Con seudónimo</h4>}>
            <Menu.ItemGroup title={<h4 style={{  color:'black'}}>General</h4>}>
              <Menu.Item>
                  <Button onClick={readPlayReportPseudo}>Ver</Button> <Button onClick={downloadPlayReport}>Descargar</Button>
              </Menu.Item>
            </Menu.ItemGroup>

              
            <Menu.ItemGroup title={<h4 style={{  color:'black'}}>Tabla actual</h4>}>
              <Menu.Item>
                  <Button onClick={readCurrentReportPseudo}>Ver</Button> <Button onClick={downloadCurrentReportPseudo}>Descargar</Button>
              </Menu.Item>
            </Menu.ItemGroup>
            <Menu.Item>
                <h4 onClick={()=>{this.setState({reportByAuthor:false},()=>onClickCountryReport())}}  style={{  color:'black'}}>Por país específico</h4>
            </Menu.Item>

            <Menu.Item style={{ fontWeight:'bold'}} >
              <h4 onClick={()=>{this.setState({reportByAuthor:false},()=>onClickGenreReport())}}  style={{  color:'black'}}>Por Genero</h4>
            </Menu.Item>
          </SubMenu>
        </SubMenu>
      <SubMenu  key="rep_conc" title = {<h4 style={{ fontWeight:'bold', color:'black'}}>Reportes de concursantes</h4>}>
        <Menu.ItemGroup style={{ fontWeight:'bold'}} title={<h4 style={{  color:'black'}}>General</h4>}>
          <Menu.Item>
            <Button onClick={readConcReport}>Ver</Button> <Button onClick={downloadConcReport}>Descargar</Button>
          </Menu.Item>
        </Menu.ItemGroup>
      </SubMenu>
  </SubMenu>
    )
    return (
      <div className="page-container">
      <div className = "content-wrap">
      <ConfigProvider locale={es_ES}>
            <Layout style={{backgroundColor:'white'}}>
               <AdminMenu defaultSelectedKey={"pon"} reportMenu={reportMenu} />
            <Spin spinning={this.state.isBusy || !this.state.logued} >
            <Content>
              <Tabs  type="card" defaultActiveKey="1" onChange={(key)=>this.onchangeTab(key)} >
                <TabPane tab="Todas las Obras" key="1">
                  <Card>
                    {this.state.selectedRows.length > 0 && 
                    <Row gutter={10}>
                      <Col>
                        <Button onClick={()=>this.qualifyAll()}>Calificar</Button>
                      </Col>
                      <Col>
                        <Button onClick={()=>this.unqualifyAll()}>Descalificar</Button>
                      </Col>
                      <Col>
                        <Button onClick={()=>this.undefinedQualifyAll()}>Sin determinar calificación</Button>
                      </Col>
                      
                    </Row>}
                <Row>
                <Col span={24}>
                  <Table
                    rowSelection={{
                      columnTitle:<Checkbox onChange={(e)=>this.setState({selectedRows: !e.target.checked ? []:this.state.plays.map(p=>p.id) })}></Checkbox>,
                      selectedRowKeys:this.state.selectedRows,
                      onChange:(rows)=>this.onChangeSelectedRows(rows),
                    }}
                    
                    columns={columns}
                    dataSource= {this.state.plays}
                    pagination={{ position: ["bottomCenter"],}} 
                    tableLayout='fixed'
                    size='small'
                    style={{ whiteSpace: 'normal'}}
                    onChange = {this.handleTableChange}
                  />
                </Col>
              </Row>
              </Card>
                </TabPane>
                <TabPane tab="Calificadas" key="2">
                <Card>
                 {this.state.selectedRows.length > 0 && <Row gutter={10}>
                 <Col>
                      <Button onClick={()=>this.qualifyAll()}>Calificar</Button>
                    </Col>
                    <Col>
                      <Button onClick={()=>this.unqualifyAll()}>Descalificar</Button>
                    </Col>
                   
                   
                  </Row>}
                <Row>
                <Col span={24}>
                  <Table
                    
                    rowSelection={{
                      columnTitle:<Checkbox onChange={(e)=>this.setState({selectedRows: !e.target.checked ? [] : this.state.plays.filter(p=>p.qualified).map(p=>p.id) })}></Checkbox>,
                      selectedRowKeys:this.state.selectedRows,
                      onChange:(rows)=>this.onChangeSelectedRows(rows),
                
                    }}
                    columns={columns}
                    dataSource= {this.state.plays.filter(p=>p.qualified)}
                    pagination={{ position: ["bottomCenter"],}} 
                    tableLayout='fixed'
                    size='small'
                    style={{ whiteSpace: 'normal'}}
                    onChange = {this.handleTableChange}
                  />
                </Col>
              </Row>
              </Card>
                </TabPane>
                <TabPane tab="Descalificadas" key="3">
                <Card>
                 {this.state.selectedRows.length > 0 && <Row gutter={10}>
                 <Col>
                      <Button onClick={()=>this.qualifyAll()}>Calificar</Button>
                    </Col>
                    <Col>
                      <Button onClick={()=>this.unqualifyAll()}>Descalificar</Button>
                    </Col>
                   
                    <Col>
                      <Button onClick={()=>this.preselectAll()}>Preseleccionar</Button>
                    </Col>
                    <Col>
                      <Button onClick={()=>this.depreselectAll()}>No Preseleccionar</Button>
                    </Col>
                  </Row>}
                    <Row>
                      <Col span={24}>
                        <Table
                          
                          rowSelection={{
                            columnTitle:<Checkbox onChange={(e)=>this.setState({selectedRows: !e.target.checked ? []:this.state.plays.filter(p=>p.qualified==undefined ? false:!p.qualified).map(p=>p.id) })}></Checkbox>,
                            selectedRowKeys:this.state.selectedRows,
                            onChange:(rows)=>this.onChangeSelectedRows(rows),
                      
                          }}
                          columns={columns}
                          dataSource= {this.state.plays.filter(p=>p.qualified==undefined ? false:!p.qualified)}
                          pagination={{ position: ["bottomCenter"],}} 
                          tableLayout='fixed'
                          size='small'
                          style={{ whiteSpace: 'normal'}}
                          onChange = {this.handleTableChange}
                        />
                      </Col>
                  </Row>
                  </Card>
                </TabPane>
                <TabPane tab="Sin determinar calificación" key="4">
                <Card>
                 {this.state.selectedRows.length > 0 && <Row gutter={10}>
                 <Col>
                      <Button onClick={()=>this.qualifyAll()}>Calificar</Button>
                    </Col>
                    <Col>
                      <Button onClick={()=>this.unqualifyAll()}>Descalificar</Button>
                    </Col>
                   
                    
                  </Row>}
                    <Row>
                      <Col span={24}>
                        <Table
                          
                          rowSelection={{
                            columnTitle:<Checkbox onChange={(e)=>this.setState({selectedRows: !e.target.checked ? []:this.state.plays.filter(p=>p.qualified==undefined).map(p=>p.id) })}></Checkbox>,
                            selectedRowKeys:this.state.selectedRows,
                            onChange:(rows)=>this.onChangeSelectedRows(rows),
                      
                          }}
                          columns={columns}
                          dataSource= {this.state.plays.filter(p=>p.qualified==undefined)}
                          pagination={{ position: ["bottomCenter"],}} 
                          tableLayout='fixed'
                          size='small'
                          style={{ whiteSpace: 'normal'}}
                          onChange = {this.handleTableChange}
                        />
                      </Col>
                  </Row>
                  </Card>
                </TabPane>
                
                
              </Tabs>
              {
                    this.state.showArticle && 
                    <Modal 
                        closable = {false}
                        title={ this.state.record.code}
                        visible={this.state.showArticle} 
                        onCancel={this.hideModal}
                        footer={[
                          
                            <Button key="back" onClick={this.hideModal}>
                            Regresar
                            </Button>,
                             
                        ]}
                    >
                        {this.state.record.author.map((a,idx)=>{return <p><UserOutlined />Autor: {a.name} </p>})}

                         <p><FileTextOutlined />Título: {this.state.record.title}</p>
                        
                        <p><QrcodeOutlined />Código: {this.state.record.code}  </p>
                        <p><CalendarOutlined />Fecha: {this.state.record.date}   </p>

                        
                        <p><ReadOutlined />Resumen: {this.state.record.resumen} </p>
                        <p>
                          <CheckOutlined />Calificada: {this.state.record.qualified == undefined ? "Sin Determinar":(this.state.record.qualified ? "Calificada":"Descalificada" )  }
                          </p>
                          <p>
                          <EmailIcon style={{color:"#e2001a", width:"1em", height:"1em"}} />Correo enviado: {this.state.record.qualified == undefined ? "No":(this.state.record.email_sended ? "Sí":"No" )  }
                          </p>
                         
  

                    </Modal>
                    || (this.state.edit && 
                      <Modal 
                          closable = {false}
                          title={ this.state.record.code}
                          visible={this.state.edit} 
                          onCancel={this.hideEdit}
                          footer={[
                            <Button key="save" onClick={()=>this.onClickSave()}>
                            Guardar
                            </Button>,
                              <Button key="back" onClick={this.hideEdit}>
                              Regresar
                              </Button>,
                          ]}
                          >
                         {this.state.record.author.map((a,idx)=>{return <p><UserOutlined />Autor: {a.name} </p>})}
                           <p><FileTextOutlined />Título: <Input style={{width:'80%'}} defaultValue={this.state.record.title} id ="inputTitle" /></p>
                          
                          <p><QrcodeOutlined />Código: {this.state.record.code}  </p>
                          <p><CalendarOutlined />Fecha: {this.state.record.date}   </p>
  
                          
                          <p><AuditOutlined />Seudónimo: <Input defaultValue={this.state.record.pseudo}style={{width:'70%'}} id="inputPseudo"/></p>
                          <p>
                          <CheckOutlined />Calificada: 
                            <Select defaultValue={this.state.record.qualified } style={{marginLeft:5}} onChange={(value)=>this.setState({qualifiedChangedValue:value, qualifiedChanged:true})}>
                              <Option value={true}>Calificada</Option>
                              <Option value={false}>Descalificada</Option>
                              <Option value={undefined}>Sin Determinar</Option>
                            </Select>  
                          </p>
                          <p>
                          <StarOutlined />Preseleccionada:
                            <Select defaultValue={this.state.record.preselected} style={{marginLeft:5}} onChange={(value)=>this.setState({preselectedChangedValue:value,preselectedChanged:true})}>
                              <Option value={true}>Preseleccionada</Option>
                              <Option value={false}>No Preseleccionada</Option>
                              <Option value={undefined}>Sin Determinar</Option>
                            </Select>  
                          </p>
                          <p>
                            
                            <Button onClick={readFile}><FilePdfOutlined/> Leer PDF</Button>
                            <Button onClick={downloadFile} >
                            <FilePdfOutlined/>  Descargar PDF
                              </Button>
                          </p>
  
                      </Modal>)
                      }
            

              {this.state.makeCountryReport &&
              <Modal
              closable = {false}
              title="Reporte por país"
              visible={this.state.makeCountryReport}
              footer={[
                <Button key="back" onClick={onClosekCountryReport}>
                Regresar
                </Button>,
            ]}
              >
                  <Select
                   style={{width:'80%'}}
                   defaultValue={this.state.reportCountry}
                   onChange={onChangeReportCountry}
                   >
                    {[...this.countries].map(c => {return <Option value={c}>{c}</Option>})}
                  </Select>
                  <div>
                    <br/>
                    <Button onClick={this.state.reportByAuthor ? readPlayReportSelectedCountry : readPlayReportSelectedCountryPseudo}>Ver</Button> <Button onClick={this.state.reportByAuthor ? downloadPlayReportSelectedCountry:downloadPlayReportSelectedCountryPseudo}>Descargar</Button>
                  </div>
              </Modal>}
                      {
                    this.state.showAuthor && 
                    <Modal 
                    closable = {false}
                        title={"Detalles de autor"}
                        visible={this.state.showAuthor} 
                        onCancel={()=>this.setState({showAuthor:false,record:null,recordAuthor:null})}
                        footer={[
                            <Button key="back" onClick={()=>this.setState({showAuthor:false,record:null,recordAuthor:null})}>
                            Regresar
                            </Button>,
                        ]}
                        >
                        <p><UserOutlined /> Nombre: {this.state.record.conc[this.state.recordAuthor].nombre + ' ' + this.state.record.conc[this.state.recordAuthor].apellidos}</p>
                        <p><UserOutlined /> Pronombre: {this.state.record.conc[this.state.recordAuthor].pronombre == 0 ? "Él": this.state.record.conc[this.state.recordAuthor].pronombre == 1 ? "Ella":"Elle" }</p>
                        <p><MailOutlined /> Email: {this.state.record.conc[this.state.recordAuthor].email}</p>
                        <p><PhoneOutlined /> Teléfono: {this.state.record.conc[this.state.recordAuthor].telefono}</p>
                        <p><ShareAltOutlined /> Redes Sociales: {this.state.record.conc[this.state.recordAuthor].redes == 0 ? "WhatsApp": this.state.record.conc[this.state.recordAuthor].redes == 1 ? "Telegram":"Signal" }</p>
                        <p><GlobalOutlined /> País: {getCountryName(this.state.record.conc[this.state.recordAuthor].pais)}</p>
                        <p><GlobalOutlined /> Pueblo: {this.state.record.conc[this.state.recordAuthor].pueblo}</p>
                        <p><HomeOutlined /> Organización: {this.state.record.conc[this.state.recordAuthor].organizacion}</p>
                        <p><IdcardOutlined /> Sintesis: {this.state.record.conc[this.state.recordAuthor].sintesis}</p>
                    </Modal>
                    }
                    { this.state.showAddPonencias && 
                    <Modal 
                      closable = {false}
                      title={ "Administara ponencias del panel"}
                      visible={this.state.showAddPonencias} 
                      width={1080}
                      footer={[
                        <Button key="save" onClick={()=>this.setState({showAddPonencias:false})}>
                          Guardar
                        </Button>,
                        <Button key="back" onClick={()=>this.setState({showAddPonencias:false})}>
                          Cancelar
                        </Button>,
                        ]}>
                      <Row align="middle" justify="center" >
                        <Col span={24}>
                          <Transfer 
                            onChange={this.handleTransferChange}
                            dataSource={ this.state.unassignedPlays}
                            targetKeys={this.state.assignedPlays}
                            listStyle={{ width: 500,height: 300}}
                            render={item => {return item.title}}
                            titles={['Sin asignar', 'Asignadas']}
                          />
                        </Col>
                      </Row>
                    </Modal>}
            </Content>
            </Spin>
          </Layout>
         
        </ConfigProvider>
    </div>
    <Foot admin={true}/>
    </div>

    );
  }
}
export default Playslist;


